import type { SigningMode } from '../orgs/api';

const CONFIG: Record<SigningMode, { label: string; description: string; classes: string }> = {
  client_side: {
    label: 'Client-side',
    description:
      'Keys are generated and signing happens in the user\'s browser.',
    classes: 'bg-gray-100 text-ink-secondary',
  },
  tee: {
    label: 'TEE',
    description:
      'Keys are managed in a hardware-attested Trusted Execution Environment.',
    classes: 'bg-emerald-50 text-emerald-700',
  },
};

export function SigningModeBadge({ mode }: { mode: SigningMode | undefined }) {
  const resolved = mode && mode in CONFIG ? mode : 'client_side';
  const { label, description, classes } = CONFIG[resolved];

  return (
    <div className="flex items-start gap-3">
      <span
        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${classes}`}
      >
        {label}
      </span>
      <p className="text-sm text-ink-secondary">{description}</p>
    </div>
  );
}
